import { DifferentiatorOutline, QuestionMarkInBox, TrophyWithKey, TwoFaces } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';

import EmptyState from '../../../KnowledgeAssetDetails/components/EmptyState';

interface KeyDifferentiatorsPageProps {
  solutionName: string;
  differentiators: string[];
  successKeyMetrics: string[];
  competitors: string[];
  trapSettingQuestions?: string[];
}

const KeyDifferentiatorsPage = ({
  differentiators = [],
  successKeyMetrics = [],
  competitors = [],
  trapSettingQuestions = [],
}: KeyDifferentiatorsPageProps) => {
  const sections = [
    {
      title: 'Differentiators',
      icon: DifferentiatorOutline,
      items: differentiators,
    },
    {
      title: 'Success Key Metrics',
      icon: TrophyWithKey,
      items: successKeyMetrics,
    },
    {
      title: 'Competitors',
      icon: TwoFaces,
      items: competitors,
    },
    {
      title: 'Trap Setting Questions',
      icon: QuestionMarkInBox,
      items: trapSettingQuestions,
    },
  ];

  return (
    <Stack className="max-w-[101.2rem] min-w-[75rem] mx-64 mt-48 mb-128" direction="col" gapY={21}>
      <Typography variant="display-xl">Key Differentiators</Typography>

      <Stack className="grid grid-cols-3 gap-16">
        {sections.map((section, index) => (
          <Stack
            key={index}
            className="border border-border rounded-12 p-20"
            direction="col"
            gapY={12}>
            <Stack alignItems="center" gapX={8}>
              <section.icon
                fill="transparent"
                fillColorToken="icon-active"
                height={24}
                width={24}
              />
              <Typography variant="heading-xs">{section.title}</Typography>
            </Stack>
            <Stack direction="col">
              {section.items.length > 0 ? (
                section.items.map((item: string, itemIndex: number) => {
                  const [title, content] = item.split('##').map((s) => s.trim());
                  const displayContent = content || item;
                  const displayTitle = content ? title : '';

                  return (
                    <Stack
                      key={itemIndex}
                      className={cn(
                        'py-12',
                        itemIndex !== section.items.length - 1 && 'border-b border-border',
                      )}
                      direction="col"
                      gapY={4}>
                      {displayTitle && <Typography variant="label-01">{displayTitle}</Typography>}
                      <Typography className="text-text-secondary" variant="body-long-01">
                        {displayContent}
                      </Typography>
                    </Stack>
                  );
                })
              ) : (
                <EmptyState />
              )}
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default KeyDifferentiatorsPage;
